import { authFetch } from './interceptors';

export const actasService = {
  // Obtener lista de actas con filtros
  getActas: async (filters = {}) => {
    try {
      //console.log('📋 Obteniendo lista de actas...', filters);
      
      const queryParams = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          queryParams.append(key, filters[key]);
        }
      });
      
      const queryString = queryParams.toString();
      const url = `/api/minutes/v1/actas/${queryString ? `?${queryString}` : ''}`;
      
      const response = await authFetch(url, {
        method: 'GET',
      });
      
      //console.log('✅ Actas obtenidas:', response);
      return response.data;
    } catch (error) {
      //console.error('❌ Error obteniendo actas:', error);
      throw error;
    }
  },

  // Obtener una acta por ID
  getActa: async (actaId) => {
    try {
      //console.log('📋 Obteniendo acta...', actaId);
      
      const acta = await authFetch(`/api/minutes/v1/actas/${actaId}/`, {
        method: 'GET',
      });
      
      //console.log('✅ Acta obtenida:', acta);
      return acta.data;
    } catch (error) {
      //console.error('❌ Error obteniendo acta:', error);
      throw error;
    }
  },

  // Crear una nueva acta CON ARCHIVOS ADJUNTOS renovado
  createActa: async (actaData, archivos = []) => {
    try {
      // PASO 4: Verificar qué llega al servicio
      //console.log('📋 actasService.createActa - INICIO', { 
      //  actaData, 
      //  archivosLength: archivos?.length,
      //  archivos: archivos?.map(a => ({ 
      //    name: a?.name, 
      //    size: a?.size, 
      //    type: a?.type,
      //    exists: !!a 
      //  }))
      //});
      
      // Si archivos es undefined o null, convertirlo a array vacío
      const archivosArray = archivos || [];
      
      //console.log('📎 Archivos a procesar:', archivosArray.length);
      
      // Crear FormData
      const formData = new FormData();
      
      // Mapeo de campos
      const fieldMapping = {
        empresa_nit: 'empresa_nit',
        hora_inicio: 'hora_inicio',
        hora_fin: 'hora_fin',
        tipo_actividad: 'tipo_actividad',
        tipo_proceso: 'proceso',
        modalidad: 'visita',
        descripcion: 'descripcion',
        nombre_persona: 'nombre_persona',
        observaciones: 'observaciones',
        cantidad_horas: 'cantidad_horas',
        valor_hora: 'valor_hora',
        valor_hora_profesional: 'valor_hora_profesional',
      };
      
      // Agregar campos del acta
      Object.keys(actaData).forEach(key => {
        if (actaData[key] !== null && actaData[key] !== undefined && actaData[key] !== '') {
          const backendKey = fieldMapping[key] || key;
          formData.append(backendKey, String(actaData[key]));
          //console.log(`📦 Campo: ${key} -> ${backendKey} = ${actaData[key]}`);
        }
      });
      
      // Agregar archivos - ESTA ES LA PARTE CRÍTICA
      if (archivosArray && archivosArray.length > 0) {
        //console.log(`📎 Adjuntando ${archivosArray.length} archivo(s) al FormData:`);
        
        archivosArray.forEach((archivo, index) => {
          if (archivo instanceof File) {
            formData.append('archivos', archivo);
            //console.log(`   ✅ Archivo ${index + 1}: ${archivo.name} (${archivo.size} bytes) - append como 'archivos'`);
          } else {
            //console.log(`   ❌ Archivo ${index + 1} no es instancia de File:`, archivo);
          }
        });
        
        // Verificar que se agregaron al FormData
        let archivosEnFormData = 0;
        for (let pair of formData.entries()) {
          if (pair[0] === 'archivos') {
            archivosEnFormData++;
          }
        }
        //console.log(`📦 Total archivos en FormData: ${archivosEnFormData}`);
        
      } else {
        //console.log('⚠️ No hay archivos para adjuntar');
      }
      
      // Debug final del FormData
      //console.log('📦 FormData completo:');
      //for (let pair of formData.entries()) {
      //  if (pair[0] === 'archivos') {
          //console.log(`   📎 ${pair[0]}: ${pair[1].name} (File)`);
      //  } else {
       //   console.log(`   📄 ${pair[0]}: ${pair[1]}`);
      //  }
      //}
      
      // Hacer la petición
      const response = await authFetch('/api/minutes/v1/actas/con-adjuntos/', {
        method: 'POST',
        body: formData,
      });
      
      //console.log('✅ Acta creada con adjuntos:', response);
      return response.data;
    } catch (error) {
      //console.error('❌ Error creando acta con adjuntos:', error);
      throw error;
    }
  },


  // Actualizar una acta
  updateActa: async (actaId, actaData) => {
    try {
      //console.log('📋 Actualizando acta...', actaId, actaData);
      
      const response = await authFetch(`/api/minutes/v1/actas/${actaId}/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(actaData),
      });
      console.log("Acta actualizada en actas.js api", response);      
      return response.data;
    } catch (error) {
      //console.error('❌ Error actualizando acta:', error);
      throw error;
    }
  },

  updateWithFiles: async (actaId, formData) => {
	console.log("enviando FormData al backend")
	for (let pair of formData.entries()) {
		console.log(pair[0], pair[1]);
	}
	try {
		const response = await authFetch(`/api/minutes/v1/actas/${actaId}/`, {
			method: 'PATCH',
			body: formData,
		});
		console.log("Respuesta del backend:", response);
		return response.data
	} catch (error){
		throw error;
	}
  },

  update: async (actaId, actaData) => {
	return await actasService.updateActa(actaId, actaData);
  },

  // Eliminar una acta
  deleteActa: async (actaId) => {
    try {
      //console.log('📋 Eliminando acta...', actaId);
      
      const response = await authFetch(`/api/minutes/v1/actas/${actaId}/`, {
        method: 'DELETE',
      });
      
      //console.log('✅ Acta eliminada:', response);
      return response;
    } catch (error) {
      //console.error('❌ Error eliminando acta:', error);
      throw error;
    }
  },

  getActasByUsuario: (usuarioUsername, filters = {}) => {
    const params = new URLSearchParams();
    
    // Agregar filtros adicionales
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    return api.get(`/actas/usuario/${usuarioUsername}/?${params.toString()}`);
  },

  getActasByEmpresa: (empresaNit, filters = {}) => {
    const params = new URLSearchParams();
    
    // Agregar filtros adicionales
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });
    
    return api.get(`/actas/empresa/${empresaNit}/?${params.toString()}`);
  },
};

// Función auxiliar para crear ZIP (usando JSZip) nueva
const crearZip = async (archivos) => {
  // Nota: Necesitas instalar jszip: npm install jszip
  const JSZip = require('jszip');
  const zip = new JSZip();
  
  archivos.forEach((archivo, index) => {
    // Usar nombre original o nombre genérico si no tiene
    const nombre = archivo.name || `archivo_${index + 1}`;
    zip.file(nombre, archivo);
  });
  
  return await zip.generateAsync({ type: 'blob' });
};
